var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.252 34.5H15.2491C14.193 34.4991 13.1998 34.0872 12.4534 33.3394L1.93861 22.8096C0.40067 21.2688 0.40067 18.7617 1.93861 17.221L16.1126 3.01984C17.5733 1.55626 19.5169 0.75 21.5851 0.75H30.5777C32.7584 0.75 34.5328 2.52398 34.5328 4.70508V13.6701C34.5328 15.7368 33.7274 17.6796 32.2652 19.1401L18.0471 33.3433C17.3002 34.0892 16.3075 34.5 15.252 34.5ZM21.5851 3.38672C20.2222 3.38672 18.9415 3.91796 17.9789 4.88242L3.80473 19.0836C3.29199 19.5974 3.29199 20.4329 3.80473 20.9466L14.3194 31.4764C14.5681 31.7255 14.8989 31.8631 15.2511 31.8633H15.2522C15.4252 31.8637 15.5966 31.8299 15.7565 31.7637C15.9164 31.6976 16.0616 31.6004 16.1837 31.4778L30.4018 17.2748C31.3654 16.3124 31.896 15.032 31.896 13.6702V4.70508C31.896 3.97813 31.3046 3.38672 30.5777 3.38672H21.5851ZM24.9745 14.1313C22.7936 14.1313 21.0194 12.3574 21.0194 10.1763C21.0194 7.99517 22.7936 6.22119 24.9745 6.22119C27.1553 6.22119 28.9295 7.99517 28.9295 10.1763C28.9295 12.3574 27.1553 14.1313 24.9745 14.1313ZM24.9745 8.85791C24.2475 8.85791 23.6561 9.44932 23.6561 10.1763C23.6561 10.9032 24.2475 11.4946 24.9745 11.4946C25.7017 11.4946 26.2928 10.9032 26.2928 10.1763C26.2928 9.44932 25.7017 8.85791 24.9745 8.85791Z",
    fill: "#005DA8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTag);
export default __webpack_public_path__ + "static/media/Tag.8cc9d434b59a953af9e67c99b3c3ee64.svg";
export { ForwardRef as ReactComponent };